import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { PublicLayout } from "../features/marketing/PublicLayout";
import { SystemStatusCard } from "../features/system/SystemStatusCard";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/status")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: StatusPage,
});

function StatusPage() {
  const t = useT();
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <div className="mx-auto w-full max-w-3xl px-4 py-12">
        <h1>{t("status.page.title")}</h1>
        <p className="text-muted-foreground mt-2">{t("status.page.lead")}</p>
        <div className="bg-card mt-8 rounded-lg border p-6">
          <SystemStatusCard />
        </div>
      </div>
    </PublicLayout>
  );
}
